import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "b-footer regular" }
const _hoisted_2 = { class: "b-footer_wrap flex middle-xs" }
const _hoisted_3 = { class: "black" }
const _hoisted_4 = { class: "link" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "link" }
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "b-build-version" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Show Test Configs ")

import { ref, computed, ComputedRef, onMounted, onBeforeUnmount } from 'vue';
  import { useStore } from 'vuex';
  import { useI18n } from 'vue-i18n';
  import { distanceInWordsToNow } from 'date-fns';
  import { BaseUrls } from 'api';
  import { CookiebotSDK } from '@/plugins/cookiebot';
  import { lazyComponent } from '@/router/routes';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'FooterComponent',
  setup(__props) {

  const ModalComponent = lazyComponent('ModalComponent');
  const ButtonComponent = lazyComponent('ButtonComponent');

  const store = useStore();
  const { t } = useI18n();

  const isBuildModalShown = ref<boolean>(false);
  const buildInfo = ref<string[]>([]);

  const VERSION: ComputedRef<string> = computed(() => process.env.VERSION);
  const termsLink: ComputedRef<string> = computed(
    () => store.getters['support/termsLinkByLocale'],
  );
  const policyLink: ComputedRef<string> = computed(
    () => store.getters['support/privacyPolicyLinkByLocale'],
  );

  function showCookiesSettings() {
    CookiebotSDK.showSettings();
  }

  function showTestTools() {
    store.commit('support/toggleConfiguratorModal', true);
  }

  function makeBuildInfoString({
    project,
    version,
    branch,
    commit,
    datetime,
  }: {
    project: string;
    version: string;
    branch?: string;
    commit?: string;
    datetime?: Date;
  }) {
    let value = `${project} ver ${version}`;
    if (branch) value += `, ${branch}`;
    if (commit) value += `${branch ? ':' : ','} ${commit.slice(0, 7)}`;
    if (datetime) {
      const utc = datetime.toLocaleDateString('en-GB', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        timeZone: 'UTC',
        timeZoneName: 'short',
      });
      const fromNow = distanceInWordsToNow(datetime, {
        includeSeconds: true,
        addSuffix: true,
      });
      value += `, ${utc} (${fromNow})`;
    }

    return value;
  }

  async function showBuildInfoModal() {
    if (!BaseUrls.isDev) return;

    let arr: string[] = [
      makeBuildInfoString({
        project: 'fp_hotel_web',
        version: VERSION.value,
        branch: process.env.BRANCH_NAME ?? '',
        commit: process.env.GIT_COMMIT ? process.env.GIT_COMMIT : '',
        datetime: process.env.START_TIME
          ? new Date(parseInt(process.env.START_TIME))
          : null,
      }),
    ];

    Promise.all([
      fetch(BaseUrls.workflowUrl).then(res => res.json()),
      fetch(BaseUrls.hotelsUrl).then(res => res.json()),
    ])
      .then(res => {
        arr.push(
          ...res.map(it => {
            const isShortInfo = typeof it.deployed === 'string';
            return makeBuildInfoString({
              project: it.name,
              version: it.version,
              branch: process.env.BRANCH_NAME ?? 'n/a',
              commit:
                !isShortInfo && it.deployed?.commit
                  ? it.deployed?.commit
                  : it.deployed,
              datetime:
                !isShortInfo && it.deployed?.date
                  ? new Date(it.deployed?.date)
                  : null,
            });
          }),
        );
        buildInfo.value = arr;
      })
      .finally(() => {
        isBuildModalShown.value = true;
      });
  }

  onMounted(() => {
    CookiebotSDK.enableWidget();
  });

  onBeforeUnmount(() => {
    CookiebotSDK.disableWidget();
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, [
        _createTextVNode(_toDisplayString(new Date().getFullYear()) + " © FinalPrice ", 1),
        _createElementVNode("span", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showBuildInfoModal()))
        }, "v." + _toDisplayString(_unref(VERSION)), 1)
      ]),
      _createElementVNode("p", _hoisted_4, [
        _createElementVNode("a", {
          class: "purpure",
          href: _unref(policyLink),
          target: "_blank",
          rel: "noopener"
        }, _toDisplayString(_unref(t)('footer.privacy')), 9, _hoisted_5)
      ]),
      _createElementVNode("p", _hoisted_6, [
        _createElementVNode("a", {
          class: "purpure",
          href: _unref(termsLink),
          target: "_blank",
          rel: "noopener"
        }, _toDisplayString(_unref(t)('footer.terms')), 9, _hoisted_7)
      ]),
      _createElementVNode("p", { class: "link" }, [
        _createElementVNode("span", {
          class: "purpure",
          style: {"cursor":"pointer"},
          onClick: showCookiesSettings
        }, " Cookies ")
      ])
    ]),
    _createVNode(_unref(ModalComponent), {
      state: isBuildModalShown.value,
      onModalClose: _cache[2] || (_cache[2] = ($event: any) => (isBuildModalShown.value = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(buildInfo.value, (info, i) => {
              return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(info), 1))
            }), 128)),
            _createVNode(_unref(ButtonComponent), {
              class: "bordered",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (showTestTools()))
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["state"])
  ]))
}
}

})